<template>
  <div data-form-mixin-root="true" :data-after="after" :data-row="row? 'true' : 'false'">
  <slot>

  </slot>
  </div>

</template>

<script>
export default {
  name: "FormMixin",
  props: {
    after: {default: "", type:String},
    row: { default: false, type:Boolean}
  },
  methods: {
    setReadOnly(val){
      this.$emit("change-read-only", val);
    }
  }
}
</script>

<style scoped>

</style>